import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ title, label, description, mediaUrl, isVideo = false, isFeatured = false, onClick }) => {
  return (
    <motion.div
      layout
      whileHover={{ y: -10, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.4 }}
      className="w-[300px] h-[450px] md:w-[280px] md:h-[420px] relative shrink-0 rounded-xl overflow-hidden bg-[#111] cursor-pointer transition-all duration-400 ease-out flex flex-col justify-end group shadow-xl"
      onClick={onClick}
    >
      {/* Media Container */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        {isVideo ? (
          <video 
            src={mediaUrl} 
            autoPlay 
            muted 
            loop 
            playsInline 
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
        ) : (
          <div 
            className="w-full h-full bg-cover bg-center bg-no-repeat transition-transform duration-700 group-hover:scale-110" 
            style={{ backgroundImage: `url(${mediaUrl})` }}
          />
        )}
      </div>

      {/* Stars Container */}
      {isFeatured && (
        <div className="absolute inset-0 z-[1] pointer-events-none overflow-hidden">
          {[...Array(4)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-[3px] h-[3px] bg-white rounded-full shadow-[0_0_8px_3px_rgba(255,255,255,0.9),0_0_15px_6px_#f8485e]"
              animate={{
                opacity: [0, 1, 0],
                scale: [0.5, 1.5, 0.5],
              }}
              transition={{
                duration: 2 + (i % 3) * 0.5,
                repeat: Infinity,
                delay: i * 0.4,
                ease: "easeInOut"
              }}
              style={{
                left: `${15 + i * 20}%`,
                top: `${20 + (i % 2) * 30}%`
              }}
            />
          ))}
        </div>
      )}

      {/* Card Overlay - bottom gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-transparent pointer-events-none z-[1]" />
      
      {/* Content */}
      <div className="relative z-[2] p-6 text-white text-left">
        <h3 className="uppercase tracking-wider mb-1 leading-none text-2xl font-extrabold drop-shadow-md">{title}</h3>
        {label && <span className="text-[14px] font-semibold tracking-[1px] uppercase block text-[#f8485e] mb-2">{label}</span>}
        <p className="text-[13px] leading-[1.4] text-white/80 line-clamp-3 mb-0">{description}</p>
      </div>
    </motion.div>
  );
};

export default Card;
